import React from 'react';
import { useAtomValue } from 'jotai';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';

import Views from '@views/Views';

import { themeCurrentThemeAtom } from '@src/store/theme';
import { OpenAPI } from '@src/api';
import {
  CLIENT_ID,
  CLIENT_SECRET,
  KAKAO_JAVASCRIPT_KEY,
  KEYWORD_API_URL,
} from '@src/constants/constant';
import { ConfigProvider } from 'antd';
import { ErrorBoundary } from 'react-error-boundary';

OpenAPI.BASE = KEYWORD_API_URL ?? '/';
OpenAPI.HEADERS = {
  'client-id': CLIENT_ID,
  'client-secret': CLIENT_SECRET,
};

declare global {
  interface Window {
    Kakao: any;
    ChannelIO: any;
    ChannelIOInitialized: boolean;
    ChannelIOVisible: boolean;
  }
}

const themes = {
  dark: `/css/dark-theme.css`,
  light: `/css/light-theme.css`,
};

function App() {
  const currentTheme = useAtomValue(themeCurrentThemeAtom);

  if (!window.Kakao?.isInitialized()) {
    // JavaScript key를 인자로 주고 SDK 초기화
    window.Kakao.init(KAKAO_JAVASCRIPT_KEY);
    // SDK 초기화 여부를 확인하자.
    console.log(window.Kakao.isInitialized());
  }

  return (
    <ErrorBoundary
      fallbackRender={({ resetErrorBoundary }) => (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            gap: '16px',
            color: '#595959',
          }}
        >
          <h2 style={{ margin: 0, fontSize: '20px' }}>
            문제가 발생했습니다
          </h2>
          <p style={{ margin: 0, fontSize: '14px', color: '#8c8c8c' }}>
            잠시 후 다시 시도해주세요.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#4285F4',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 24px',
              fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            새로고침
          </button>
        </div>
      )}
    >
      <div className="App">
        <ThemeSwitcherProvider
          themeMap={themes}
          defaultTheme={currentTheme}
          insertionPoint="styles-insertion-point"
        >
          <ConfigProvider>
            <BrowserRouter>
              <Routes>
                <Route path="*" element={<Views />} />
              </Routes>
            </BrowserRouter>
          </ConfigProvider>
        </ThemeSwitcherProvider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
